module.exports = __webpack_public_path__ + "static/media/ep3in.b9e8c586.png";